import {Component, Input, OnInit} from '@angular/core';
import {SingleAdditionModel} from '../../../../../models/questions/subModels/singleAddition.model';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-single-addition',
  templateUrl: './evo-single-addition.component.html',
  styleUrls: ['./evo-single-addition.component.css']
})
export class EvoSingleAdditionComponent implements OnInit {

  Enums = Enums;
  @Input() question: QuestionModel = new SingleAdditionModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): SingleAdditionModel {

    return <SingleAdditionModel>this.question;
  }

  getOutcomeString(): string {

    const minOutcome = this.castedQuestion().model.firstRange.minValue() + this.castedQuestion().model.secondRange.minValue();
    const maxOutcome = this.castedQuestion().model.secondRange.maxValue() + this.castedQuestion().model.secondRange.maxValue();

    if (this.castedQuestion().model.maxOutcome !== null &&
      this.castedQuestion().model.minOutcome !== null) {

      return '[' + this.castedQuestion().model.minOutcome.toString(10) + ', ' +
        this.castedQuestion().model.maxOutcome.toString(10) + ']';

    } else if (this.castedQuestion().model.minOutcome !== null) {

      return '[' + this.castedQuestion().model.minOutcome.toString(10) + ', ' +
        maxOutcome + ']';

    } else if (this.castedQuestion().model.maxOutcome !== null) {

      return '[' + minOutcome + ', ' +
        this.castedQuestion().model.maxOutcome.toString(10) + ']';

    }

    let outcome = '[' + minOutcome.toString(10) + ', ';
    outcome += maxOutcome + ']';

    return outcome;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.singleAddition) {
        return true;
      }
    }

    return false;
  }

}
